export const NEWS_TAB_NAME = {
	HOT_PURSUIT: 'Hot pursuits',
	NEWS: 'News',
	ANNOUNCEMENTS: 'Announcements',
};